module.exports = __webpack_public_path__ + "assets/img/line6.3090faa7.png";